<template>
  <div class="table-container">
    {{
      changeLang /* Данное вычисляемое свойство ничего не возвращает. Оно находится здесь, чтобы при изменении в нем данных отпрабатывал код внтури функции */
    }}
    <div class="row justify-between">
      <h3 class="table-container__heading">{{ $t("securities") }}</h3>
      <div class="table-container__controls controls">
        <date-picker
          :lang="$t('short lang')"
          :confirm="true"
          class="controls__item controls__date-picker"
          value-type="format"
          :value="userPortfolioDate"
          @change="handleDatePickerChange"
          :clearable="false"
          :placeholder="$t('select date')"
          :not-after="new Date()"
          format="DD.MM.YYYY"
        />
        <!--                :value="incomeDateRange"-->

        <input
          v-model="searchQuery"
          type="search"
          class="controls__item controls__search"
          :placeholder="$t('search')"
        />
      </div>
    </div>
    <div
      style="position: relative;"
      v-show="isTableLoading"
      class="table__preloader"
    >
      <spinner :animation-duration="1000" :size="60" :color="'#2E79EF'" />
    </div>
    <div v-if="!isTableLoading">
      <table class="table-container__table table">
        <thead>
          <tr>
            <td class="table__head" style="width: 25%; text-align: center">
              {{ $t("title") }}
            </td>
            <td class="table__head" style="text-align: center">
              {{ $t("sec type") }}
            </td>
            <td class="table__head" style="text-align: center">
              {{ $t("deal type") }}/{{ $t("deal date") }}
            </td>
            <td class="table__head" style="text-align: center">
              {{ $t("category_sec") }}
            </td>
            <td class="table__head" style="text-align: center">
              {{ $t("coupon rate") }}
            </td>
            <td class="table__head" style="text-align: center">
              {{ $t("maturity date") }}
            </td>
            <td class="table__head" style="text-align: center">
              {{ $t("rating") }}
            </td>
            <td class="table__head" style="text-align: center">
              {{ $t("market price") }}
            </td>
            <td class="table__head" style="text-align: center">
              {{ $t("nominal_value") }}
            </td>
            <td class="table__head" style="text-align: center">
              {{ $t("market cost") }}
            </td>
            <td class="table__head" style="text-align: center">
              {{ $t("purchase value") }}
            </td>
            <td class="table__head" style="width: 25%; text-align: center">
              {{ $t("income coupon") }}/{{ $t("dividends") }}
            </td>
            <td class="table__head" style="width: 15%">
              {{ $t("profitability") }}/ <br />{{ $t("lesion") }}
            </td>
            <td class="table__head" style="text-align: center">
              {{ $t("currency") }}
            </td>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="security in filteredUserPortfolio"
            :key="
              String(security.DEAL_DATE) +
                String(security.ISIN) +
                String(security.DEAL_PRICE)
            "
          >
            <td class="table__body" style="overflow-x: hidden">
              {{ security.SECURITY_NAME }}
              <br />
              <span style="color: #2e79ef">{{ security.ISIN }}</span>
            </td>
            <td class="table__body align-center">
              {{ security.SECURITY_TYPE }}
            </td>
            <td class="table__body align-center">
              {{ security.DEAL_KIND }}<br />
              <span style="white-space: nowrap">{{ security.DEAL_DATE }}</span>
            </td>
            <td class="table__body align-center">{{ security.CATNAME }}</td>
            <td class="table__body align-right">{{ security.FEE_RATE }}</td>
            <td class="table__body align-center">
              {{ security.MATURITY_DATE }}
            </td>
            <td class="table__body align-center">
              <span style="white-space: nowrap">{{
                security.RATING_SP ? `S&P: ${security.RATING_SP}` : null
              }}</span
              ><br />
              <span style="white-space: nowrap">{{
                security.RATING_MOODY ? `Moody: ${security.RATING_MOODY}` : null
              }}</span
              ><br />
              <span style="white-space: nowrap">{{
                security.RATING_FITCH ? `Fitch: ${security.RATING_FITCH}` : null
              }}</span>
            </td>
            <td class="table__body align-right">
              {{ formatMoney(security.PRICE, 4) }}
            </td>
            <td class="table__body align-right">
              {{ formatMoney(security.QTY_BY_VALUE, 0) }}
            </td>
            <td class="table__body align-right">
              {{ formatMoney(security.AMOUNT_SECCUR) }}
            </td>
            <td class="table__body align-right">
              {{ formatMoney(security.DEAL_AMOUNT_SECCUR) }}
            </td>
            <td class="table__body align-right">
              {{
                formatMoney(security.INCOME_COUPON) ||
                  formatMoney(security.INCOME_DIV)
              }}
            </td>
            <td class="table__body">
              <button
                v-if="security.PROFITABILITY !== null"
                class="graph-button"
                @click="openProfitability(security)"
              >
                <div class="row middle-xs">
                  <div class="col-xs start-xs">
                    <b
                      :style="{
                        color:
                          reformat_profitability(security.PROFITABILITY) > 0
                            ? 'green'
                            : 'red'
                      }"
                      >{{
                        $formatMoney(
                          reformat_profitability(security.PROFITABILITY)
                        )
                      }}%
                    </b>
                  </div>
                  <div class="col-xs end-xs">
                    <svg
                      width="20px"
                      version="1.1"
                      id="Capa_1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 512.008 512.008"
                      style="enable-background:new 0 0 512.008 512.008;"
                      xml:space="preserve"
                    >
                      <g>
                        <g>
                          <path
                            d="M510.352,108.04c-1.097-2.646-2.689-5.012-4.668-6.992c-0.129-0.129-0.258-0.151-0.366-0.258
			c-1.936-1.829-4.152-3.356-6.647-4.389c-2.044-0.839-4.195-1.097-6.346-1.291c-0.645-0.043-1.183-0.344-1.829-0.344H318.395
			c-11.896,0-21.513,9.616-21.513,21.513s9.616,21.513,21.513,21.513h120.385L268.485,309.054l-64.796-82.953
			c-3.743-4.797-9.315-7.766-15.338-8.218c-6.26-0.452-12.026,1.678-16.414,5.83L6.72,380.132
			c-8.627,8.175-8.992,21.792-0.839,30.419c4.26,4.453,9.939,6.69,15.64,6.69c5.314,0,10.627-1.958,14.779-5.873l148.028-140.155
			l65.248,83.533c3.808,4.883,9.509,7.874,15.683,8.239c6.174,0.344,12.176-1.936,16.543-6.303l187.181-188.257V288.38
			c0,11.896,9.616,21.513,21.513,21.513c11.896,0,21.513-9.616,21.513-21.513V116.28v-0.022
			C511.987,113.44,511.427,110.665,510.352,108.04z"
                          />
                        </g>
                      </g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                    </svg>
                  </div>
                </div>
              </button>
            </td>
            <td class="table__body align-center">
              {{ security.CURRENCY_CODE }}
            </td>
          </tr>
        </tbody>
      </table>
      <div class="total" v-if="userPortfolioTotal">
        <span>{{ $t("total") }}:</span>
        <span
          >{{ formatMoney(userPortfolioTotal[getSelectedCurrency]) }}
          {{ getCurrencySignByTicker(getSelectedCurrency) }} <br />
        </span>
        <span
          class="total_sub_price"
          v-for="(price, key) in userPortfolioTotal"
        >
          <span v-if="key != getSelectedCurrency">
            {{ getCurrencySignByTicker(key) }} {{ formatMoney(price) }}
          </span>
        </span>
        <br />
        <span style="font-size: 11px;color: #888787;"
          >по курсу на {{ userPortfolioDate }}
        </span>
      </div>
    </div>
    <modal
      width="70%"
      height="auto"
      name="portfolio-detail-chart"
      :style="'border-radius:8px;'"
    >
      <div class="chart-in-modal" v-if="market_data">
        <!-- <h3>
          Рыночная цена <span style="color: #2e79ef">{{ market_data.ISIN }}</span> за период c
          {{ market_data.bdate }} по {{ market_data.edate }}
        </h3>
        <div v-if="market_data.market">
          <h4>Источник данных: {{ market_data.market }}</h4>
        </div>
        <br />
        <br /> -->
        <line-chart
          :options="profitChartOptions(market_data.values)"
        ></line-chart>
      </div>
    </modal>
  </div>
</template>

<script>
import { HalfCircleSpinner } from "epic-spinners";
import { Chart } from "highcharts-vue";
import HighCharts from "highcharts";
import {
  months,
  shortMonths,
  weekdays,
  shortWeekdays
} from "@/config/dateTranslations";
import i18n from "@/lib/vue-i18n/index";
import { FhsAxios } from "../../../services/axios";
import DatePicker from "vue2-datepicker";
import { replaceCommas, formatMoney, income } from "@/helpers/money";
import { isLoading } from "@/helpers/loading";
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  components: {
    lineChart: Chart,
    spinner: HalfCircleSpinner,
    "date-picker": DatePicker
  },
  data() {
    return {
      searchQuery: "",
      market_data: null
    };
  },
  computed: {
    isTableLoading() {
      // console.log(isLoading(this.userPortfolio));
      return isLoading(this.userPortfolio);
    },
    filteredUserPortfolio() {
      // Перехватываем начальное сотояние null, а также другие ошибки
      if (!this.userPortfolio) {
        return [];
      }
      // Фильтруем массив по строке поиска
      return this.userPortfolio.filter(
        item =>
          !item.SECURITY_NAME.toLowerCase().indexOf(
            this.searchQuery.toLowerCase()
          )
      );
    },
    changeLang() {
      let selectedLang = i18n.locale;
      // Переводим график
      HighCharts.setOptions({
        lang: {
          months: months[selectedLang],
          shortMonths: shortMonths[selectedLang],
          weekdays: weekdays[selectedLang],
          shortWeekdays: shortWeekdays[selectedLang]
        }
      });
      return null;
    },
    ...mapGetters([
      "userPortfolio",
      "userPortfolioTotal",
      "userPortfolioDate",
      "getCurrencySignByTicker",
      "getSelectedCurrency",
      "displayingCurrency",
      "currencySign",
      "incomeChartOptions",
      "isUserVIP",
      "rate"
    ])
  },
  methods: {
    profitChartOptions(profit_series) {
      let income = profit_series;
      // Отлавливаем ошибки
      if (!income) {
        income = [];
      }
      return {
        chart: {
          zoomType: "x"
        },
        title: {
          text: `${this.market_data.name} <span style="color: #2e79ef;">${
            this.market_data.ISIN
          }</span>`
        },
        subtitle: {
          text:
            document.ontouchstart === undefined
              ? "Кликните и перетаскивайте курсор для увеличения масштаба"
              : "Pinch the chart to zoom in"
        },
        yAxis: {
          title: {
            text: `Рыночная цена, ${this.market_data.currency}`
          }
          // labels: {
          //   format: `{value} ${this.market_data.currency}`
          // }
        },
        xAxis: {
          type: "datetime",
          dateTimeLabelFormats: {
            day: "%d.%m.%y",
            week: "%d.%m.%y",
            month: "%b %Y",
            year: "%Y"
          },
          crosshair: true
        },
        tooltip: {
          pointFormat: "<b>{point.y:.5f}</b>"
        },
        legend: {
          enabled: false
        },
        series: [
          {
            name: "Рыночная цена",
            data: income.map(incomeItem => {
              let date = moment(incomeItem.date, "DD.MM.YYYY");
              return [
                Date.UTC(date.year(), date.month(), date.date()),
                Number(incomeItem.price)
              ];
            })
          }
        ]
      };
    },
    reformat_profitability(money) {
      return parseFloat(money.replace(",", ".")).toFixed(2);
    },
    formatMoney,
    getIncome(amount, dealAmount) {
      return income(replaceCommas(amount), replaceCommas(dealAmount));
    },

    // Возвращаем класс для окраски блока в зависимости от дохода (красный - убыток, зеленый - доход)
    getIncomeColor(income) {
      if (Math.sign(income) === 1) {
        return "table__body_green";
      } else if (Math.sign(income) === -1) {
        return "table__body_red";
      }
    },
    handleDatePickerChange(date) {
      this.$store.commit("unsetUserPortfolio");
      this.$store.dispatch("setPortfolioDate", date);
      this.$store.dispatch("fetchUserPortfolio");
    },
    openProfitability(object) {
      FhsAxios.get("user/market-price", {
        params: {
          isin: object.ISIN,
          b_date: object.DEAL_DATE,
          e_date: this.userPortfolioDate
        }
      }).then(res => {
        if (res.data.status) {
          //console.log(res.data);
          if (res.data.result.error.length > 0) {
            this.market = null;
            this.$toasted.error(res.data.result.error);
          } else {
            this.market_data = res.data.result;
            this.$modal.show("portfolio-detail-chart");
          }
        } else {
          this.market = null;
          this.$toasted.error("Ошибка загрузки данных");
        }
      });
    }
  },
  mounted() {
    // Если портфель еще не был загружен, то загружаем его
    this.$store.dispatch("fetchUserPortfolio");
  }
};
</script>

<style scoped>
.total {
  text-align: right;
  font-size: 20px;
  margin: 55px;
}
.total span {
  padding: 5px;
}
.table-container {
  padding: 30px 30px 0;
}
.total_sub_price {
  font-size: 14px;
}
.table-container__heading {
  font-size: 36px;
  font-weight: normal;
}

.table-container__select:not(:first-child) {
  margin-left: 15px;
}

.table {
  position: relative;
  margin: 40px 0 0;
}
.table__body {
  font-size: 12px;
}
.table__body:first-child,
.table__head:first-child {
  padding-left: 0px;
}
.table__preloader {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  min-height: 250px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
}

.controls {
  height: 39px;
}

.controls__item {
  height: 100%;
  padding: 0 12px;
  font-size: 15px;
  background-color: #ffffff;
  border: 1px solid #acb5c5;
  border-radius: 5px;
  outline: none;
}

.controls__date-picker {
  border: none;
}

@media all and (max-width: 1600px) {
  .table-container {
    padding: 30px 25px 0;
  }
}
@media all and (max-width: 1200px) {
  .table-container {
    padding: 20px 15px 0;
  }
  .title {
    font-size: 26px;
  }
  .table__body {
    font-size: 12px;
  }
  .table__head {
    font-size: 12px;
  }
}

.graph-button {
  cursor: pointer;
  width: 100%;
  padding: 5px 10px;
  border: none;
  background-color: rgba(0, 0, 0, 0.05);
  border-radius: 5px;
  outline: none;
  transition: all 0.2s;
}
.graph-button:hover {
  transform: scale(1.1);
  background-color: #1a75e9;
}
.graph-button:hover b {
  color: white !important;
}
.graph-button:hover svg {
  fill: white !important;
}

.graph-button svg {
  fill: #1a75e9;
}
.chart-in-modal {
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
}
</style>
